import { useState } from 'react';

const faqs = [
  {
    question: 'NG南宫APP在哪里下载？',
    answer: '您可以通过NG南宫官方网站下载页面，选择iOS或Android版本进行下载。iOS用户可跳转至App Store安装，Android用户可直接下载APK安装包。请务必从官方渠道下载以确保安全。',
  },
  {
    question: 'NG南宫APP是否免费下载？',
    answer: '是的，NG南宫APP完全免费下载安装。平台上的基础游戏均可免费畅玩，部分游戏内含有可选付费内容，您可以根据个人需求选择是否购买。',
  },
  {
    question: 'NG南宫支持哪些设备平台？',
    answer: 'NG南宫全面支持iOS（iPhone/iPad）、Android手机和平板设备，部分游戏还提供PC桌面版客户端，让您在不同设备上都能享受优质游戏体验。',
  },
  {
    question: '下载安装过程安全吗？',
    answer: 'NG南宫所有安装包均经过多重安全检测和国际权威安全认证，不含任何病毒、恶意软件或捆绑程序。我们采用高级加密技术保护您的设备和数据安全，请放心下载使用。',
  },
  {
    question: '如何获取最新版本的NG南宫APP？',
    answer: '打开已安装的NG南宫APP，系统会自动检测并提示更新。您也可以定期访问NG南宫官网下载页面，手动下载最新版本安装包进行更新，获取最新功能和游戏体验。',
  },
  {
    question: '安装过程中遇到问题怎么办？',
    answer: '如果在安装过程中遇到任何问题，您可以查看我们的下载教程页面获取详细指导，或联系7×24小时在线客服团队，我们将第一时间为您解决问题。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于NG南宫下载和使用过程中的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between gap-3 p-4 md:p-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
              >
                <span className="text-sm font-medium text-foreground-800">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 text-base flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-xs text-foreground-500 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}